import { ScanBarcode } from "lucide-react";

export const Logo = ({ className = "", onClick }) => (
  <div className={`flex items-center gap-2.5 ${className}`} onClick={onClick} role="link">
    <span className="flex h-8 w-8 items-center justify-center rounded-md bg-volt">
      <ScanBarcode className="h-5 w-5 text-white" strokeWidth={2.2} />
    </span>
    <span className="font-display text-xl font-extrabold tracking-tight text-slate-900">STOCKARIS</span>
  </div>
);
